import React, { useState } from 'react';
import {Routes, Route} from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChiamaEInoltra from './ChiamaEInoltra';
import CallLog from './CallLog';
import Rubrica from './Rubrica';
import Configurazione from './Configurazione';
import ListaFaq from './ListaFaq';
import Faq from './Faq';
import Chiamata from './Chiamata';
import ChiamataAzioni from './ChiamataAzioni';
import ChiamataInviaIstruzioni from './ChiamataInviaIstruzioni';
import Contatto from './Contatto';
import ContattoInfo from './ContattoInfo';
import ContattoPriorita from './ContattoPriorita';
import Referenti from './Referenti';
import Referente from './Referente';
import StatoServizio from './StatoServizio';
import PaypalSuccess from './paypal/Success';
import PaypalCancel from './paypal/Cancel';
import Notifiche from './Notifiche';
import { isReferentePrincipale } from '../utils';
import InviaMessaggio from './InviaMessaggio';

const Rotte = ()=> {
    const authData = useSelector(state => state.auth.authData);    
    return  <Routes>
                <Route path="/" element={<CallLog />}/>
                <Route path="/sendmessage" element={<InviaMessaggio />}/>
                <Route path="/chiamaeinoltra" element={<ChiamaEInoltra />}/>
                <Route path="/configurazione" element={<Configurazione />} />
                <Route path="/listafaq" element={<ListaFaq />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/rubrica" element={<Rubrica />}/>                
                <Route path="/call-actions" element={<ChiamataAzioni />}/>
                <Route path="/call-action-invia-istruzioni" element={<ChiamataInviaIstruzioni />}/>
                <Route path="/call-info" element={<Chiamata />}/>
                <Route path="/contatto" element={<Contatto />}/>
                <Route path="/contatto-info" element={<ContattoInfo />}/>
                <Route path="/contattopriorita" element={<ContattoPriorita />}/>
                {isReferentePrincipale(authData?.user) &&
                    <>
                        <Route path="/referenti" element={<Referenti />} />
                        <Route path="/referente" element={<Referente />} />
                    </>
                }
                <Route path="/stato_servizio" element={<StatoServizio />} />
                <Route path="/paypal/success" element={<PaypalSuccess />} />
                <Route path="/paypal/cancel" element={<PaypalCancel />} />
                <Route path="/notifiche" element={<Notifiche />} />
                {/* Aggiungi altre rotte qui */}
                {/* <Route component={NotFound}/> */}                
            </Routes>
}
export default Rotte;